import {
  getSingleChoiceValue,
  PLAYER_PORTALS_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';
import { getFirstMappedLinkedItemOrDefault } from './utils';

export const player_portals_championship = (
  input: PLAYER_PORTALS_MODELS.PlayerPortalsChampionship | undefined,
) => {
  if (!input || !input?.elements) {
    return undefined;
  }

  const { elements } = input;

  return {
    name: elements.name?.value,
    landingPageLink: getFirstMappedLinkedItemOrDefault(elements.landing_page),
    kontentCollection: getSingleChoiceValue(
      elements.kontent_collections__associated_kontent_collection,
    ),
    championshipIdentifier: elements.championship_identifier?.value,
    website: elements.website?.value,
  };
};

export default player_portals_championship;
